import { IconX } from "@tabler/icons-react";
import type { BandeauInformation as BandeauInformationModel } from "../../../models/bandeauInformation";
import IconButton from "../IconButton";
import Button from "../Button";
import Title from "../Title";
import Text from "../Text";
import styles from "./BandeauInformation.module.css";

interface BandeauInformationProps {
  bandeau: BandeauInformationModel;
  /** Si fourni, affiche la croix de fermeture à gauche du message. */
  onClose?: () => void;
}

export default function BandeauInformation({
  bandeau,
  onClose,
}: BandeauInformationProps) {
  return (
    <div className={styles.bandeau} role="status">
      {onClose && (
        <IconButton
          icon={IconX}
          label="Fermer le bandeau"
          size="sm"
          onClick={onClose}
          className={styles.close}
        />
      )}
      <div className={styles.content}>
        {bandeau.titre && (
          <Title as="div" variant="deca" weight="bold">
            {bandeau.titre}
          </Title>
        )}
        {bandeau.texte && <Text as="div">{bandeau.texte}</Text>}
      </div>
      {bandeau.lien && (
        <Button
          nativeButton={false}
          className={styles.action}
          render={
            bandeau.lien_nouvel_onglet ? (
              <a
                href={bandeau.lien}
                target="_blank"
                rel="noopener noreferrer"
              />
            ) : (
              <a href={bandeau.lien} />
            )
          }
        >
          Voir l'offre
        </Button>
      )}
    </div>
  );
}
